import React, { useState } from 'react';
import { login } from '../../services/auth';
import { getAccountSettings } from '../../services/settings';
import { applyTheme } from '../../utils/themeUtils';
import './LoginForm.css';

const LoginForm = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);

      // Cargar y aplicar el theme de la cuenta
      try {
        const settings = await getAccountSettings();
        if (settings.theme) {
          applyTheme(settings.theme);
        }
      } catch (themeError) {
        console.error('Error loading theme:', themeError);
      }

      onSuccess();
    } catch (err) {
      setError('Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-container"
      style={{
        backgroundImage: `linear-gradient(45deg, #00BA73 0%, #4C1CD2 100%), url(/assets/bg.svg)`
      }}
    >
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="login-logo">
          <img src="/assets/logo.svg" alt="Zurria AI" />
        </div>

        <div className="form-group">
          <label>Usuario o email *</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Contraseña *</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <button type="submit" disabled={loading} className="btn-submit">
          {loading ? 'Iniciando...' : 'Iniciar sesión'}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;